$(document).ready(function() {
  mobile_menu();
  search_toggle();
});

$(window).on('resize', function() {
  reset_header();
});


var $html = $('html'),
    $toggable = $('.header--navigation'),
    $mobileMenu = $('.menu-main-toggle');

// mobile menu toggling
function mobile_menu() {
    // mobile menu toggle
    $mobileMenu.on('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if ( !$(this).hasClass('active') ) {
        $mobileMenu.addClass('active').attr('aria-label', 'Close the main menu navigation');

        $toggable.show();

        setTimeout(function() {
          $toggable.addClass('active');
          $html.addClass('menu-is-open').attr('draggable', false);
        }, 250);
      }
      else {        
        $mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

        $html
          .removeClass('menu-is-open')
          .attr('draggable', true)
          .removeClass('submenu-is-open');

        $toggable.removeClass('active');

        setTimeout(function() {
          $toggable.hide();

          // resets active submenus and search
          $('.submenu--revealed > div > .subnav-trigger').trigger('click');
          $('.search-block.active + .toggle').trigger('click');
        }, 250);
      }
    });
  }

function search_toggle() {
  $('#searchToggle').on('click', function(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if ( !$(this).prev('.active').length ) {
      $(this).prev('.search-block')
        .show()
        .addClass('active');
    }
    else {
      $(this).prev('.search-block')
        .removeClass('active')
        .hide();
    }
  });

  $('.tools-menu-navigation').on('click', '#searchToggle-alt', function(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    $('#searchToggle').trigger('click');
  });
}

// reset menus on window resize
  function reset_header() {
    if ( $mobileMenu.css('display') == 'none' ) {
      if ( $('.menu-is-open').length ) {
        $mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

        $html
          .removeClass('menu-is-open')
          .attr('draggable', true)
          .removeClass('submenu-is-open');

        $toggable.removeClass('active');
        $toggable.show();
        
        $('.submenu--revealed > div > .subnav-trigger').trigger('click');
        $('.search-block.active + .toggle').trigger('click');
      }
      else {
        $toggable.show();
      }
    }
  }